import { ChangeEvent, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

type PasswordFormInputProps = {
  id: string | undefined;
  value?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  validationMessage: string | "";
  placeholder?: string;
};

export default function PasswordFormInput(props: PasswordFormInputProps) {
  const { id, value, onChange, validationMessage, placeholder } = props;

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((prev) => !prev);
  };

  return (
    <>
    <div className="text-left relative">
      <input
        id={id}
        value={value}
        onChange={onChange}
        type={isPasswordVisible ? "text" : "password"} 
        placeholder={placeholder ?? "Password"}
        className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-300 pr-10"
      />
      <button
        type="button"
        onClick={togglePasswordVisibility}
        className="absolute inset-y-0 right-3 text-gray-300"
      >
        <FontAwesomeIcon icon={isPasswordVisible ? faEye : faEyeSlash} />
      </button>
    </div>
    {validationMessage && <span className="text-red-600">{validationMessage}</span>}
    </>
  );
}
